<template>
	<svg
		width="14px"
		height="17px"
		viewBox="0 0 14 17"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		alt="microphone off icon"
	>
		<g
			stroke="none"
			stroke-width="1"
			:fill="color"
			fill-rule="evenodd"
			opacity="0.899171"
		>
			<g
				transform="translate(-462.000000, -82.000000)"
				:fill="color"
				fill-rule="nonzero"
			>
				<g transform="translate(443.000000, 69.000000)">
					<path
						d="M28.0286585,21.1825113 C28.0447524,21.1250614 28.0527993,21.0594043 28.0527993,21.0019544 L28.0527993,15.8642893 C28.0527993,14.1654128 26.9664634,13 25.4375462,13 C23.9730044,13 22.951044,14.0669273 22.8544808,15.6262825 L22.8544808,15.905325 L28.0286585,21.1825113 Z M32.0279841,27.4527607 C32.2532982,27.2147539 32.2613452,26.8290186 32.0279841,26.5910118 L20.0219605,14.362384 C19.7885994,14.1243772 19.4103936,14.1243772 19.1689856,14.362384 C18.9436715,14.5921837 18.9436715,14.9943332 19.1689856,15.224133 L31.1830562,27.4527607 C31.4164172,27.6907676 31.80267,27.6907676 32.0279841,27.4527607 Z M28.8896803,29.8000007 C29.2517923,29.8000007 29.5495288,29.5045439 29.5495288,29.1352229 C29.5495288,28.7659019 29.2517923,28.4704452 28.8896803,28.4704452 L26.0813008,28.4704452 L26.0813008,26.787983 C26.9745103,26.7059116 27.7792036,26.4514905 28.4631929,26.049341 L27.5297487,25.0808994 C26.9262287,25.3845633 26.2261456,25.5569131 25.4375462,25.5569131 C22.8383869,25.5569131 21.1082964,23.8005867 21.1082964,21.1578899 L21.1082964,19.6559846 C21.1082964,19.2866637 20.8105599,18.9912069 20.4484479,18.9912069 C20.078289,18.9912069 19.7885994,19.2866637 19.7885994,19.6559846 L19.7885994,21.2071327 C19.7885994,24.3422574 21.8244734,26.5089404 24.7857446,26.787983 L24.7857446,28.4704452 L21.9773651,28.4704452 C21.6152531,28.4704452 21.3175166,28.7659019 21.3175166,29.1352229 C21.3175166,29.5045439 21.6152531,29.8000007 21.9773651,29.8000007 L28.8896803,29.8000007 Z M30.5553954,23.7513439 C30.8933666,23.0127019 31.078446,22.150953 31.078446,21.2071327 L31.078446,19.6559846 C31.078446,19.2866637 30.7887565,18.9912069 30.4266445,18.9912069 C30.0564856,18.9912069 29.766796,19.2866637 29.766796,19.6559846 L29.766796,21.1578899 C29.766796,21.7159749 29.6782797,22.2330243 29.5173411,22.6926237 L30.5553954,23.7513439 Z M25.4375462,23.9154865 C25.7191888,23.9154865 25.9927846,23.8662437 26.2422395,23.7759653 L22.8142461,20.2797267 L22.8142461,21.0511972 C22.8142461,22.7500737 23.900582,23.9154865 25.4375462,23.9154865 Z"
					></path>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'MicOff',
	props: {
		color: {
			type: String,
			default: '#ffffff',
		},
	},
}
</script>
